import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexAllReports from "./allReports/IndexAllReports";
import GenerateReport from "./allReports/components/GenerateReport";
import GenerateClassBasedReport from "./allReports/components/GenerateClassBasedReport";

const ReportsModules = () => {
  return (
    <Routes>
      <Route path="all-reports" element={ <IndexAllReports modkey="reportsAll"/> } />
      <Route path="all-reports/generate/:id" element={ <GenerateReport /> } />
      <Route path="all-reports/generate-class/:id" element={ <GenerateClassBasedReport /> } />

    </Routes>
  );
}

export default ReportsModules;
